import { usePollOptionsState } from "./PollOptionsState";
import { usePostFormPollMediaFilesUploadInputStore } from "./PollsTabSections/PostFormPollMediaFilesUploadInput.store";
import { PollTypesEnum } from "../../../../Shared/Types/Polls";
import { MAX_IMAGES_COUNT } from "./PollsTabSections/ImagesOptions";

export function useIsPollsValid() {
    const { pollType, getFilteredPollOptions } = usePollOptionsState();
    const { images, isUploading } = usePostFormPollMediaFilesUploadInputStore();

    const pollFilteredOptions = getFilteredPollOptions();
    const validImages = images.filter(
        (image) => !image.delete && !image.isInappropriate,
    );

    switch (pollType) {
        case PollTypesEnum.POLL_HIDDEN:
        case PollTypesEnum.POLL_VISIBLE:
            return pollFilteredOptions.length >= 2;
        case PollTypesEnum.POLL_QUIZ:
            return (
                pollFilteredOptions.length >= 2 &&
                pollFilteredOptions.some(
                    ({ isCorrectAnswer }) => isCorrectAnswer,
                )
            );
        case PollTypesEnum.POLL_RATING:
            return true;
        case PollTypesEnum.POLL_IMAGES:
            return (
                !isUploading &&
                validImages.length > 1 &&
                validImages.length <= MAX_IMAGES_COUNT
            );
        default:
            return false;
    }
}
